export default {
	meta: {
		title: 'Indicateurs',
		description: 'Indicateurs'
	}
};
